import React from "react";
import { Row, Col } from "antd";

const InsuranceCoverage = () => {
  return (
    <div className="InsuranceCoverage">
      <div className="dshbrd_acrdn Delinquencies">
        <p className="alert alert-info">
          <i className="fa-solid fa-circle-exclamation"></i> Save time and reduce
          gaps in insurance coverage with Smart Enrollment.
          <a
            className="js-leasing-activity-income-verification-link"
            target="_blank"
            rel="noopener noreferrer"
            href="/"
          >
            Learn More
          </a>
        </p>
        <p>Tenant Insurance</p>
        <Row>
          <Col span={12}>
            <div className="chart x-60">
              <p>1</p>
              <p className="mute">Total</p>
            </div>
          </Col>
          <Col span={12}>
            <div
              className="collected"
              style={{ borderLeft: "5px solid #21971d" }}
            >
              <a href="/">
                <span className="widget-info-box__datum ">0</span>
              </a>
              <h2 className="widget-info-box__description">
                Renters Insurance
              </h2>
            </div>
            <div
              className="collected"
              style={{ marginTop: "10px", borderLeft: "5px solid #2ca5dc" }}
            >
              <a href="/">
                <span className="widget-info-box__datum ">0</span>
              </a>

              <h2 className="widget-info-box__description">
                Liability to Landlord Insurance
              </h2>
            </div>

            <div
              className="collected"
              style={{ marginTop: "10px", borderLeft: "5px solid #86367e" }}
            >
              <a href="/">
                <span className="widget-info-box__datum ">0</span>
              </a>

              <h2 className="widget-info-box__description">
                Both Renters and Liability to Landlord Insurance
              </h2>
            </div>
            <div
              className="collected"
              style={{ marginTop: "10px", borderLeft: "5px solid #f09b58" }}
            >
              <a href="/">
                <span className="widget-info-box__datum ">0</span>
              </a>

              <h2 className="widget-info-box__description">
                Policy Expiring in Next 30 Days
              </h2>
            </div>
            <div
              className="collected"
              style={{ marginTop: "10px", borderLeft: "5px solid #c04e44" }}
            >
              <a href="/">
                <span className="widget-info-box__datum ">1</span>
              </a>

              <h2 className="widget-info-box__description">No Insurance</h2>
            </div>
          </Col>
        </Row>
      </div>
      <br />
      <Row>
        <Col span={8}>
          <div className="InsuranceTotalValues">
            <h3>0.00%</h3>
            <p>TOTAL COVERAGE</p>
          </div>
        </Col>
        <Col span={8}>
          <div className="InsuranceTotalValues">
            <h3>0.00%</h3>
            <p>RENTERS INSURANCE COVERAGE</p>
          </div>
        </Col>
        <Col span={8}>
          <div className="InsuranceTotalValues">
            <h3>0.00%</h3>
            <p>LIABILITY TO LANDLORD COVERAGE</p>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default InsuranceCoverage;
